import React from "react";
import cx from "classnames";

import styles from "./choice.module.scss";
import { classMapper } from "../utils";

const classMap = {
  type: {
    radio: styles.choiceRadio,
    checkbox: styles.choiceCheckbox
  },
  size: {
    small: styles.choiceSmall,
    medium: styles.choiceMedium
  }
};

export namespace Choice {
  export type Props = Omit<React.HTMLProps<HTMLInputElement>, "size"> & {
    indeterminate?: boolean;
    checked: boolean;
    error?: boolean;
    loading?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    size?: keyof typeof classMap.size;
    type: keyof typeof classMap.type;
    value?: string;
  };
}

export const Choice = ({
  checked,
  children,
  className,
  error = false,
  loading,
  onChange,
  indeterminate = false,
  size = "medium",
  type,
  value,
  ...props
}: Choice.Props): JSX.Element => {
  const classList = cx(
    className,
    styles.choice,
    ...classMapper(classMap, {
      type,
      size
    }),
    error && styles.choiceError,
    indeterminate && styles.choiceIndeterminate,
    loading ? styles.choiceLoading : styles.choiceNotLoading
  );

  return (
    <div className={classList}>
      <input
        {...props}
        checked={checked}
        className={styles.choiceInput}
        onChange={onChange}
        type={type}
        value={value}
      />
      {children}
    </div>
  );
};
